import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import logoFull from "../assets/tenditaly-logo-full.png";

export default function ResetPassword() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("La password deve avere almeno 6 caratteri");
    if (password !== confirm) return toast.error("Le due password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password aggiornata! Ora puoi accedere.");
      nav("/login");
    } catch (err) {
      const msg = err?.response?.data?.detail;
      toast.error(typeof msg === "string" ? msg : "Reimpostazione non riuscita");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8"><img src={logoFull} alt="TENDItaly" className="h-16 object-contain" /></div>
        <h2 className="font-head text-2xl font-bold text-center">Nuova password</h2>
        <p className="text-sm text-muted-foreground text-center mb-8">Scegli una nuova password per il tuo accesso.</p>

        {!token ? (
          <div className="text-center space-y-4">
            <p className="text-sm text-destructive">Link non valido o incompleto.</p>
            <Button className="w-full bg-brand text-white" onClick={() => nav("/login")}>Torna all'accesso</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="pw">Nuova password</Label>
              <Input id="pw" data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <div>
              <Label htmlFor="pw2">Conferma password</Label>
              <Input id="pw2" data-testid="reset-password-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
            </div>
            <Button type="submit" data-testid="reset-submit" disabled={busy} className="w-full bg-brand hover:bg-[#A8472F] text-white">
              {busy ? "Attendi…" : "Salva nuova password"}
            </Button>
            <button type="button" onClick={() => nav("/login")} className="text-sm text-brand font-medium underline w-full text-center">Torna all'accesso</button>
          </form>
        )}
      </div>
    </div>
  );
}
